import { ReactNode, useMemo } from 'react'
import _ from 'lodash'
import { splitCommaString } from '@fusion-advantage/formlib'
import L3Erf from '../l3/L3Erf'
import { useConceptsArray } from '../../../redux/selectConcept'
import { L4PrintBound } from './L4Print'

interface L4ErfProps {
	xpath: string
	titleCids?: string
	contentTitle?: string
	contentTitles?: string
	children?: ReactNode
}

const L4Erf = ({xpath, titleCids, contentTitle, contentTitles, children}: L4ErfProps) => {
	const titleCidArray = useMemo((): string[] => {
		return titleCids ? (splitCommaString(titleCids) ?? []) : []
	}, [titleCids])
	const titleConcepts = useConceptsArray(titleCidArray)
	const contentTitleArray = useMemo(() => {
		if(contentTitles) {
			return splitCommaString(contentTitles) ?? undefined
		}
		if(contentTitle) {
			return [contentTitle]
		}
	}, [contentTitles, contentTitle])
	return (
		<L4PrintBound xpath={xpath}>
			<L3Erf
				controlTitleConcepts={titleConcepts}
				contentTitles={contentTitleArray}
				children={children}
			/>
		</L4PrintBound>
	)
}

export default L4Erf
